import ReactRailsUJS from 'react_ujs';
import createAsyncWrapper from './createAsyncWrapper';

export default function setupReact(componentsContext) {
  ReactRailsUJS.getConstructor = (name) => {
    return createAsyncWrapper(name, componentsContext);
  };

  // Tear down any existing event listeners that react_ujs set up
  if (ReactRailsUJS.removeEvent && ReactRailsUJS.handleMount) {
    ReactRailsUJS.removeEvent('DOMContentLoaded', ReactRailsUJS.handleMount);
    ReactRailsUJS.removeEvent('turbolinks:load', ReactRailsUJS.handleMount);
    ReactRailsUJS.removeEvent('turbo:load', ReactRailsUJS.handleMount);
  }

  // Unmount any components that were already mounted
  ReactRailsUJS.unmountComponents();

  // Prevent future detectEvents calls from setting up listeners
  ReactRailsUJS.detectEvents = () => {};

  // Set up our own controlled mounting
  document.addEventListener('turbo:load', () => { ReactRailsUJS.mountComponents() });
  document.addEventListener('turbo:before-render', () => { ReactRailsUJS.unmountComponents() });
  document.addEventListener('state:template-rendered', (event) => {
    ReactRailsUJS.mountComponents(event.detail.container);
  });
}
